import { ErrorPage } from "../errors/error-page";
import React from "react";

type ServiceDisruptionProps = {
  reason: string;
}

export function ServiceDisruption(props: ServiceDisruptionProps) {
  return (
    <ErrorPage
      title="Temporary Service Disruption"
      description={(
        <div>
          <p>We are currently experiencing a service disruption to Blue J. For direct updates as new information becomes
            available, please visit our <a className="text-fg-brand-strong" href="https://status.askbluej.com/" target="_blank"
              rel="noreferrer noopener">status page</a>.</p>
          <p><small>reason: {props.reason}</small></p>
        </div>
      )}
    />
  )
}

export enum ServiceDisruptionReasonCode {
  UserError = '10001',
  ConfigError = '10002',
  StrategyError = '10003',
  UserPreferencesError = '10004'
}
